export enum LocalStorageKeys {
	Step = 'agreementsCurrentStep',
	State = 'agreementsCheckboxState',
}
